export const priceFields = [
  'discountedPrice',
  'price(FULL)',
  'recommendedPrice',
  'onSale',
  'url'
];
